export const BASE_FORM_ERROR_MESSAGE = {
  th: 'กรุณากรอกข้อมูลให้ครบถ้วน',
  en: 'Please fill in all the required fields',
};

export const FULLNAME_ERROR_MESSAGE = {
  MIN_LENGTH: {
    th: 'กรุณากรอกชื่ออย่างน้อย 2 ตัวอักษร',
    en: 'First name must be at least 2 characters',
  },
  MAX_LENGTH: {
    th: 'ชื่อต้องมีความยาวไม่เกิน 50 ตัวอักษร',
    en: 'First name must not exceed 50 characters',
  },
  INVALID_FORMAT: {
    th: 'กรุณากรอกชื่อ-นามสกุลเป็นภาษาไทยหรือภาษาอังกฤษเท่านั้น',
    en: 'Please enter your name and surname in Thai or English only',
  },
};

export const MOBILE_ERROR_MESSAGE = {
  REQUIRED: {
    th: 'กรุณากรอกเบอร์โทรศัพท์',
    en: 'Please enter a phone number',
  },
  INVALID_FORMAT: {
    th: 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง',
    en: 'Please enter a valid phone number',
  },
};

export const EMAIL_ERROR_MESSAGE = {
  INVALID_FORMAT: {
    th: 'รูปแบบอีเมลไม่ถูกต้อง',
    en: 'Please enter a valid email address',
  },
};

export const LOCATION_ERROR_MESSAGE = {
  PROVINCE_REQUIRED: {
    th: 'กรุณาเลือกจังหวัด',
    en: 'Please select a province',
  },
  DEALER_REQUIRED: {
    th: 'กรุณาเลือกผู้จำหน่าย',
    en: 'Please select a dealer',
  },
};

export const LINE_ID_ERROR_MESSAGE = {
  INVALID: {
    th: 'กรุณากรอก LINE ID ให้ถูกต้อง',
    en: 'Please enter a valid LINE ID',
  },
  MAX_LENGTH: {
    th: 'LINE ID ต้องมีความยาวไม่เกิน 20 ตัวอักษร',
    en: 'LINE ID must not exceed 20 characters',
  },
};

export const PRIVACY_ERROR_MESSAGE = {
  REQUIRED: {
    th: 'กรุณายอมรับนโยบายคุ้มครองข้อมูลส่วนตัว',
    en: 'Please accept the privacy policy',
  },
};

export const getErrorMessage = (
  messageObj: { th: string; en: string },
  locale: 'th' | 'en' = 'th'
) => {
  const message = messageObj[locale];
  return message || undefined;
};
